export default {
  reservations: 'Reservas',
  activated: 'Activada',
  deactivated: 'Desactivada',
  reservations_deactivated: 'Las reservas están desactivadas.',
  tabs: {
    general: 'General',
    information: 'Información',
  },
  sections: {
    notifications_confirmation: 'Notificaciones y confirmación',
    notifications_confirmation_description: 'Cómo reservan los clientes y cómo recibe usted las notificaciones.',
    who_can_book: 'Quién puede reservar',
    who_can_book_description: 'Límites de tamaño de grupo para reservas en línea.',
    when_how_bookings_work: 'Cuándo y cómo funcionan las reservas',
    when_how_bookings_work_description:
      'Reglas de horario, duración y capacidad que determinan los turnos disponibles.',
  },
  google: {
    label: 'Mostrar reservas en Google',
  },
  storefront: {
    label: 'Mostrar reservas en la tienda',
  },
  auto_confirm: {
    label: 'Confirmar reservas automáticamente',
  },
  email: {
    label: 'Correo para reservas entrantes',
    add: 'Añadir correo',
    placeholder: 'Introducir correo',
    required: 'Añade al menos un correo electrónico para recibir las nuevas reservas.',
    invalid: 'Introduce una dirección de correo electrónico válida.',
  },
  has_whatsapp_phone_number: {
    label: 'Enviar notificaciones por WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'Número de WhatsApp',
    add: 'Añadir número de teléfono',
  },
  party_size: {
    label: 'Tamaño de grupo permitido por reserva',
    min_label: 'Mín.',
    max_label: 'Máx.',
    to: 'a',
    guests: 'comensales',
    helper:
      'Tamaño mínimo y máximo de una reserva. Un comensal solo puede reservar para un número de personas dentro de este rango.',
    warning:
      'Google solo acepta reservas de 2 a 16 comensales. Las reservas fuera de este rango seguirán funcionando en su tienda, pero no aparecerán en Google.',
    warning_min: 'Google recomienda un mínimo de 2 comensales por reserva.',
    warning_max: 'Google recomienda un máximo de 16 comensales por reserva.',
    min_note: 'Google no ofrecerá reservas para grupos de menos de {{count}} personas.',
  },
  time_slot: {
    label: 'Intervalo de reserva',
    helper: 'Los clientes pueden reservar en incrementos de estos minutos.',
    extra: 'p. ej. {{example}}',
  },
  reservation_gap: {
    label: 'Límite de reserva antes del cierre',
    helper: 'La última hora en que un cliente puede iniciar una reserva, contada desde la hora de cierre.',
    helper_link: 'Ver los horarios de reserva',
    extra: 'p. ej. cierre a las 22:00, límite {{example}} min → último inicio posible a las {{example}}',
  },
  reservation_notice_period: {
    label: 'Antelación mínima',
    helper: 'La antelación mínima con la que un cliente puede reservar antes de su llegada.',
    extra: 'p. ej. reserve antes de las {{example}} para una llegada a las 18:00',
  },
  opening_times: {
    label: 'Horario de apertura',
  },
  total_seats: {
    label: 'Capacidad total de comensales',
    helper:
      'El número máximo de comensales (no mesas) que pueden estar sentados al mismo tiempo. Cuente los asientos individuales; p. ej. 5 mesas de 4 = 20.',
  },
  capacity_explainer: {
    title: 'Cómo funciona la capacidad',
    body: 'Esta es la cantidad de comensales que puede atender a la vez. Cada reserva ocupa sus asientos durante su duración y los libera para los siguientes clientes. El sistema garantiza el espacio necesario para todos los reservados, evitando el exceso de reservas.',
    body_example:
      'Ejemplo: con 20 asientos, puede aceptar una reserva de 12 comensales a las 19:00 y otra de 10 comensales a las 21:00, porque los asientos del primer grupo se liberan antes de que llegue el siguiente.',
  },
  note: {
    label: 'Nota',
  },
  grace_period: {
    label: 'Período de gracia',
    helper: 'Tiempo que se mantiene reservada una mesa tras la hora de inicio de la reserva.',
    tooltip:
      'Margen adicional tras la duración de una reserva antes de ofrecer de nuevo la mesa (p. ej. para limpiarla y prepararla).',
    extra: 'p. ej. reservada hasta las {{example}} para una reserva a las 18:00',
    placeholder: 'Introducir período de gracia',
  },
  information: {
    rules: {
      label: 'Su mesa estará reservada durante:',
      add: 'Añadir',
    },
  },
  reservation_duration: {
    label: 'Duración de la reserva',
    helper: 'Tiempo que se mantiene reservada cada mesa por reserva.',
    tooltip:
      'Tiempo que se reserva una mesa por cada reserva. Se utiliza para calcular cuándo vuelve a estar disponible para el siguiente comensal.',
    extra: 'p. ej. 18:00 – {{example}}',
    minutes: '{{ count }} minutos',
    hour_one: '{{ count }} hora',
    hour_other: '{{ count }} horas',
  },
  buttons: {
    save: 'Guardar',
    activate: 'Activar',
    deactivate: 'Desactivar',
  },
  success_messages: {
    updated: 'Actualización correcta',
    saving_successful:
      'Actualización correcta. Tenga en cuenta que Google puede tardar hasta 24 horas en reflejar los cambios.',
  },
  error_messages: {
    invalid_phone_number: 'Número de teléfono no válido',
    saving_unsuccessful: 'Error al guardar los cambios. Inténtelo de nuevo.',
    enter_correct_email: 'Por favor, introduce una dirección de correo válida.',
  },
};
